export default {
  title: 'New User',
  save: 'Save',
  create: 'Create',
  firstName: 'First Name',
  lastName: 'Last Name',
  email: 'E-mail',
  repeatEmail: 'Repeat E-mail',
  setPasswordManually: 'Set password manually (no e-mail will be sent to the user)',
  password: 'Password',
  repeatPassword: 'Repeat Password',
  phoneNumber: 'Phone Number (If present will require 2FA)',
  domain: 'Domain',
  true: 'True',
  false: 'False',
  firstNameRequired: 'First Name is Required',
  lastNameRequired: 'Last Name is Required',
  emailRequired: 'E-mail is Required',
  emailInvalid: 'E-mail Must be Valid',
  emailExists: 'E-mail already exists',
  emailsMustMatch: 'E-mails Must Match',
  passwordRequirements: 'Password Must be Over 12 Characters, and must contain numeric, lowercase, uppercase, and special characters (#, ?, !, @, $, %, ^, *, -)',
  passwordsMustMatch: 'Passwords Must Match',
  phoneNumberInvalid: 'Phone number must start with the +X country code'
}
